import { render, staticRenderFns } from "./Decentralized.vue?vue&type=template&id=d3b7b76a&"
import script from "@/scripts/components/systemManager/decentralized.js?vue&type=script&lang=js&"
export * from "@/scripts/components/systemManager/decentralized.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports